export default "__VITE_ASSET__C8vUj6p5__"